import { __assign } from "tslib";
import { packageAttributes } from './index';
import { end } from 'perf-marks';
export function closedEvent(input) {
    var _a = end('MediaViewer.SessionDuration').duration, duration = _a === void 0 ? 0 : _a;
    return {
        eventType: 'ui',
        action: 'closed',
        actionSubject: 'mediaViewer',
        actionSubjectId: undefined,
        attributes: __assign(__assign({}, packageAttributes), { sessionDurationMs: duration, input: input }),
    };
}
//# sourceMappingURL=closed.js.map